export const getEnvironmentDetails = () => {
  const environmentName = process.env.NAME as typeof process.env.NODE_ENV;

  const environment = {
    environmentName,
    isProductionEnvironment: environmentName === 'production',
    isTestEnvironment: environmentName === 'test',
    isDevelopmentEnvironment: environmentName === 'development',
  };

  return environment;
};
